/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var WidgetType;
(function (WidgetType) {
    WidgetType[WidgetType["KPI"] = 1] = "KPI";
    WidgetType[WidgetType["CHART"] = 2] = "CHART";
    WidgetType[WidgetType["VARIABLE"] = 3] = "VARIABLE";
    WidgetType[WidgetType["TREECHANGE"] = 4] = "TREECHANGE";
    WidgetType[WidgetType["SINGLEVALUE"] = 5] = "SINGLEVALUE";
    WidgetType[WidgetType["SIMULATION"] = 6] = "SIMULATION";
    WidgetType[WidgetType["SLICER"] = 7] = "SLICER";
    WidgetType[WidgetType["TAGSLICER"] = 8] = "TAGSLICER";
    WidgetType[WidgetType["DATAEDITOR"] = 9] = "DATAEDITOR";
    WidgetType[WidgetType["TEXTTILE"] = 10] = "TEXTTILE";
    WidgetType[WidgetType["PIVOT"] = 11] = "PIVOT";
})(WidgetType || (WidgetType = {}));
export function WidgetTypeFromJSON(json) {
    return WidgetTypeFromJSONTyped(json, false);
}
export function WidgetTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function WidgetTypeToJSON(value) {
    return value;
}
